'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mustache = require('mustache');
var constants = require('./constants.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);

const getStepperInfo = (status, statusCode) => {
  const STEPS = constants.getSteps(statusCode);
  switch (status) {
    case 'LDORDERPLACED':
      return STEPS[constants.PREVIEW_LOCAL_DELIVERY_ORDER_PLACED];
    case 'LDPICKUPINPROGRESS':
      return STEPS[constants.PREVIEW_LOCAL_DELIVERY_PICKUP_IN_PROGRESS];
    case 'LDONITSWAY':
      return STEPS[constants.PREVIEW_LOCAL_DELIVERY_ON_ITS_WAY];
    case 'LDDELIVERED':
      return STEPS[constants.PREVIEW_LOCAL_DELIVERY_DELIVERED];
    case 'HPUSCHEDULED':
      return STEPS[constants.PREVIEW_HPU_SCHEDULED];
    case 'HPUPICKEDUP':
      return STEPS[constants.PREVIEW_HPU_PICKED_UP];
    case 'HPUPICKUPINPROGRESS':
      return STEPS[constants.PREVIEW_HPU_PICKUP_IN_PROGRESS];
    case 'MVINTRANSIT':
      return STEPS[constants.PREVIEW_MAPVIEW_ON_ITS_WAY];
    case 'MVDELIVERED':
      return STEPS[constants.PREVIEW_MAPVIEW_DELIVERED];
    case 'LDEXCEPTION':
    case 'HPUEXCEPTION':
    case 'MVEXCEPTION':
    default:
      return STEPS[constants.PREVIEW_LOCAL_DELIVERY_EXCEPTION];
  }
};
const renderTemplate = (template, view) => mustache__default["default"].render(template, view, undefined, {
  escape: x => x
});
const addAlpha = (color, opacity) => {
  if (opacity < 0 || opacity > 1) {
    return color;
  }
  return color + Math.round(opacity * 255).toString(16).toUpperCase();
};

exports.addAlpha = addAlpha;
exports.getStepperInfo = getStepperInfo;
exports.renderTemplate = renderTemplate;
